import { Types } from '@store/types';

const initialState = [];

const PONumberReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_ORDER_PO_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default PONumberReducer;
